module.exports = __webpack_public_path__ + "static/img/jointext1.7566187.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/jointext1.png
// module id = K5YM
// module chunks = 1